import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { PricesDataService, PricesColumnsService } from '../../../services';
import { Price, PricesResult } from '../../../interfaces';

@Component({
  selector: 'app-price-form',
  templateUrl: './price-form.component.html',
  styleUrls: ['./price-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class PriceFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public price: Price = {};
  public priceForm: FormGroup = new FormGroup({});
  public prices: Price[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private pricesDataService: PricesDataService,
    public pricesColumnsService: PricesColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'PriceFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Price - Edit');
        this.getPrice(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.price !== 'undefined') {
      this.price = this.dynamicDialogConfig.data.price;
    }
    if (typeof this.price.id === 'undefined' || this.price.id === null) {
      this.price.id = null;
    }
    this.getPrices();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'PriceFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'PriceFormComponent');
  }

  getPrice(id: number): void {
    this.isLoading = true;
    this.pricesDataService.getPrice(id).subscribe((response: Price|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.price = response;
        this.prepareFrom();
      }
    });
  }

  getPrices(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.prices !== 'undefined' && this.dynamicDialogConfig.data.prices.length > 0) {
      this.prices = this.dynamicDialogConfig.data.prices;
      return;
    }
    this.pricesDataService.getPrices(this.parameters).subscribe((response: PricesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.prices = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.priceForm = new FormGroup({
      id: new FormControl(this.price.id, []),
      name: new FormControl(this.price.name, [Validators.required, ]),
      nameAr: new FormControl(this.price.nameAr, []),
      nameFr: new FormControl(this.price.nameFr, []),
      amount: new FormControl(this.price.amount, [Validators.required, ]),
      currency: new FormControl(this.price.currency, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/prices']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.priceForm.controls).forEach((field: any) => {
        const control = this.priceForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.priceForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.price = this.priceForm.value;
    this.disableSubmit = true;
    console.log('price', this.price);
    if (typeof this.price.id !== 'undefined' && this.price.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.pricesDataService.updatePrice(this.price).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('PRICEUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('PRICENOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.pricesDataService.addPrice(this.price).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('PRICECREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('PRICENOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-price-form',
  templateUrl: './price-form.component.html',
  styleUrls: ['./price-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogPriceFormComponent extends PriceFormComponent {
}

